import React, { useContext } from "react";
import { LanguageContext } from "../LanguageContext";
import SEO from "../components/SEO";
import { Link } from "react-router-dom";
import "./InformationalPages.css";

const Aboutus = () => {
  const { language } = useContext(LanguageContext);

  const metaTitle = "About Us - Snapseed QR Codes | Mission & Team";
  const metaDescription = "Discover our mission behind Snapseed QR Codes. Learn about our values, vision, and commitment to digital editing enthusiasts.";
  const metaUrl = "https://www.snapseedqrcodes.download/about";
  const metaImage = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp";

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://www.snapseedqrcodes.download/"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "About Us",
        "item": metaUrl
      }
    ]
  };

  return (
    <div className="informational-page">
      <SEO
        title={metaTitle}
        description={metaDescription}
        url={metaUrl}
        image={metaImage}
        schemaMarkup={breadcrumbSchema}
      />

      <h1>{language === "english" ? "About Us" : "हमारे बारे में"}</h1>

      <p className="section-description searchable-content">
        {language === "english"
          ? "Welcome to Snapseed QR Codes – your trusted source for discovering, sharing, and creating Snapseed editing styles via QR codes."
          : "Snapseed QR Codes में आपका स्वागत है – Snapseed संपादन शैलियों को QR कोड के माध्यम से खोजने, साझा करने और बनाने का आपका भरोसेमंद स्रोत।"}
      </p>

      <h3>{language === "english" ? "Who We Are" : "हम कौन हैं"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? <>We are a team of digital editing enthusiasts who believe in simplifying workflows using technology. Our mission is to empower creators worldwide with free and accessible Snapseed QR Codes. To learn about our values and how we protect your data, please review our <Link to="/privacy-policy">Privacy Policy</Link>.</>
          : <>हम डिजिटल संपादन के प्रति उत्साही लोगों की एक टीम हैं जो तकनीक के माध्यम से वर्कफ़्लो को सरल बनाने में विश्वास रखते हैं। हमारा मिशन वैश्विक रचनाकारों को मुफ़्त और सुलभ Snapseed QR Codes के साथ सशक्त बनाना है। हमारे मूल्यों और आपके डेटा की सुरक्षा के बारे में जानने के लिए कृपया हमारी <Link to="/privacy-policy">गोपनीयता नीति</Link> पढ़ें।</>
        }
      </p>

      <h3>{language === "english" ? "What We Offer" : "हम क्या पेश करते हैं"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? <>We curate high-quality Snapseed QR code presets for various editing needs. Whether you’re a beginner or pro, you’ll find tools that suit your creative vision. Have suggestions? <Link to="/contact">Contact us</Link> today.</>
          : <>हम विभिन्न संपादन आवश्यकताओं के लिए उच्च-गुणवत्ता वाले Snapseed QR कोड प्रीसेट क्यूरेट करते हैं। चाहे आप एक शुरुआती हों या पेशेवर, आपको अपनी रचनात्मक दृष्टि के अनुरूप टूल्स मिलेंगे। सुझाव हैं? <Link to="/contact">हमसे संपर्क करें</Link>।</>
        }
      </p>

      <h3>{language === "english" ? "Our Commitment" : "हमारी प्रतिबद्धता"}</h3>
      <p className="section-description searchable-content">
        {language === "english"
          ? <>We are committed to maintaining transparency and ethical practices. You can learn more in our <Link to="/terms">Terms and Conditions</Link>.</>
          : <>हम पारदर्शिता और नैतिक प्रथाओं को बनाए रखने के लिए प्रतिबद्ध हैं। आप हमारे <Link to="/terms">नियम और शर्तों</Link> में और जान सकते हैं।</>
        }
      </p>
    </div>
  );
};

export default Aboutus;
